import styled from "styled-components";

const WorkSansSnippet = styled.span`
  font-family: "Work Sans Variable", sans-serif;
  font-size: 1.5em;
  line-height: 1;
`;

export default WorkSansSnippet;
